var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmenityBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#17A2B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26H12C10.8954 26 10 25.1046 10 24V12C10 10.8954 10.8954 10 12 10H24C25.1046 10 26 10.8954 26 12V18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.834 26.2061L18.2563 22.6284C17.9077 22.2797 17.9077 21.7144 18.2563 21.3657C18.605 21.017 19.1704 21.017 19.519 21.3657L22.6758 24.5225",
    stroke: "white",
    strokeWidth: 1.30217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4614 24.311L21.6196 23.4692C21.3941 23.2437 21.306 22.9149 21.3885 22.6068C21.4711 22.2987 21.7118 22.058 22.0199 21.9755C22.328 21.8929 22.6568 21.981 22.8823 22.2065L23.9346 23.2588",
    stroke: "white",
    strokeWidth: 1.30217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3032 22.6284C22.9545 22.2797 22.9545 21.7144 23.3032 21.3657C23.6519 21.017 24.2172 21.017 24.5659 21.3657L25.1973 21.9971",
    stroke: "white",
    strokeWidth: 1.30217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9882 21.7872C24.6395 21.4385 24.6395 20.8732 24.9882 20.5245C25.3369 20.1758 25.9022 20.1758 26.2509 20.5245L28.1449 22.4185C29.5397 23.8133 29.5397 26.0746 28.1449 27.4693L27.3031 28.3111L27.3907 28.2236C26.5413 29.0733 25.3215 29.439 24.1447 29.1967C24.0751 29.1823 24.0055 29.1677 23.936 29.1529C23.603 29.0826 22.3386 28.74 20.142 28.1251C19.6764 27.9947 19.3991 27.5175 19.5165 27.0484C19.6401 26.5539 20.0843 26.2069 20.594 26.2066H21.8315",
    stroke: "white",
    strokeWidth: 1.30217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenityBooking);
export default __webpack_public_path__ + "static/media/amenity-booking.8f147ed939b0490a2e2ae3a947ecc83b.svg";
export { ForwardRef as ReactComponent };